export default "__VITE_ASSET__DQxyjcoJ__"